import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";
import { categoryImages } from "@/mocks/categoryImages";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {categories.map((c) => (
        <a
          key={c.id}
          href={c.link}
          target="_blank"
          rel="noopener nofollow"
          className="group flex flex-col overflow-hidden rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
        >
          <div className="relative w-full h-40 overflow-hidden">
            <img
              src={categoryImages[c.id]}
              alt={t(c.nameKey)}
              title={`${t(c.nameKey)} — USFans Spreadsheet`}
              className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
            />
          </div>
          <div className="flex items-center justify-between px-4 py-3">
            <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap overflow-hidden text-ellipsis">{t(c.nameKey)}</span>
            <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors shrink-0">
              <i className="ri-arrow-right-up-line text-base" />
            </span>
          </div>
        </a>
      ))}
    </div>
  );
}